


























import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator'
@Component({
  components: {
  },
})
export default class ConfirmModal extends Vue {
  @Prop({ type: Boolean, default: false }) show!: boolean;
  private visible: boolean = false
  private spinning: boolean = false


  created() {
    this.visible = this.show
  }
  afterClose() {
    this.$emit('update:show', false)
  }
  select(value:any){
    this.visible = false
    this.$emit('onConfirm',value)
  }
  handleOk() {
    
  }
  handleCancel() {
    this.visible = false
  }

}
